import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';
import { AppMessages } from '../../shared/constants/messages';
import { AppConstants } from '../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { Utility } from '../../common/utility';
import { ValidationService } from '../../shared/services/validation.service';
import { Patient } from '../../models/patient/patient.model'

@Component({
  selector: 'add-patient',
  templateUrl: 'add-patient.component.html'
})
export class AddPatientComponent implements OnInit {
  public patientForm: FormGroup;
  public patientModel = new Patient();

  // just for test
  public listTitle: any[] = ['Bishop', 'Br', 'Dr', 'Fr', 'Master', 'Miss', 'Mr', 'Mrs', 'Ms', 'Prof', 'Rev', 'Sir', 'Sr'];
  public listCountryOfBirth: any[] = ['NoiSinh', 'Lao', 'Campuchia'];
  public listCountry: any[] = ['VN', 'Lao', 'Campuchia'];
  public listOccupation: any[] = ['aoie', 'besse', 'oif'];

  constructor(
    public utility: Utility,
    private formBuilder: FormBuilder,
    private router: Router) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.patientForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      surName: ['', [Validators.required]],
      sex: ['', [Validators.required]],
      dateOfBirth: ['', [Validators.required, ValidationService.isValidDateOfBirth]],
      countryOfBirth: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      country: ['', [Validators.required]],
      email: ['', [Validators.required, ValidationService.isValidEmail]],
      occupation: ['', [Validators.required]],
    });
  }

  onSubmit() {
    if(this.patientForm.valid && this.patientForm.dirty) {
      console.log("Add success", this.patientModel);
    }
  }

  onCancel() {
    this.router.navigate(['/list-member']);
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/add-patient/add-patient.component.ts